import FooterStyle from './FooterStyle'
// import linked from '../../images/icons/icon-linkedin.svg'
// import youtube from '../../images/icons/icon-youtube.svg'
// import twitter from '../../images/icons/icon-twitter.svg'
import itch from '../../images/icons/icon-itch-white.svg'
import KickStarter from '../../images/icons/KS_icon_FA.svg'
import styled from 'styled-components'
// import { ReactComponent as ItchIcon } from '../../images/icons/icon-itch-white.svg'

const IconBox = styled.div`
  display: flex;
  gap: 0.25rem;

  img {
    width: 2rem;
    height: auto;
    transition: transform 0.2s;

    &:hover {
      transition: all 1s ease;
      transform: scale(1.1);
    }
  }
`

const Footer = () => {
  return (
    <FooterStyle>
      <div className="footer-info">Copyright 2026 © by Seaside Studios.</div>
      <IconBox>
        <a
          href="https://seasidestudios.itch.io/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={itch} alt="itch.io" />
        </a>
        <a
          href="https://www.kickstarter.com/profile/seaside-studios/created"
          target="_blank"
          rel="noreferrer"
        >
          <img src={KickStarter} alt="KickStarter.com" />
        </a>
      </IconBox>
    </FooterStyle>
  )
}

export default Footer
